import { ORM } from 'redux-orm';
import Row from './entity/Row';
import Sector from './entity/Sector';
import Seat from './entity/Seat';
import Configuration from './entity/Configuration';
import Hall from './entity/Hall';
import RoundTable from './entity/RoundTable';
import RectangleTable from './entity/RectangleTable';
import GeneralAdmission from './entity/GeneralAdmission';
import Shape from './entity/Shape';
import TicketType from './entity/TicketType';
import Reservation from './entity/Reservation';

const orm = new ORM();
orm.register(
    Sector,
    Row,
    Seat,
    Configuration,
    Hall,
    RoundTable,
    RectangleTable,
    GeneralAdmission,
    Shape,
    TicketType,
    Reservation,
);

export default orm;
